import { render, staticRenderFns } from "./ListApprovedRequestPage.vue?vue&type=template&id=068c36b5"
import script from "./ListApprovedRequestPage.vue?vue&type=script&lang=js"
export * from "./ListApprovedRequestPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports